import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HukukiRehberlikVeDanismanlik() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll();
  return <section id="hukuki-rehberlik-ve-danışmanlık" className="dark bg-background text-foreground relative w-full overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#0B111D,#2F353B)] z-0" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 h-full">
        <div className="flex flex-col lg:flex-row min-h-[85vh] items-center">
          
          {}
          <div ref={textRef} className={`w-full lg:w-[60%] py-12 lg:py-24 lg:pr-16 flex flex-col justify-center transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-8 max-w-2xl">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#C5A059]/10 border border-[#C5A059]/30 text-[#C5A059] text-sm font-medium tracking-wide">
                <span className="w-1.5 h-1.5 rounded-full bg-[#C5A059] animate-pulse" />
                Isparta Hukuk ve Arabuluculuk Ofisi
              </div>

              <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-serif font-bold leading-[1.1] text-[#CCD6E0] tracking-tight">
                Hukuk ve Arabuluculukta Güvenilir Çözümler
              </h1>

              <p className="text-lg md:text-xl text-white/90 leading-relaxed font-sans font-light border-l-2 border-[#C5A059]/40 pl-6">
                2017'den beri Isparta'da kesintisiz hizmet veren Av. Arb. Muhammed Çelik Isparta Hukuk ve Arabuluculuk Ofisi; 
                hukukun üstünlüğü ilkesiyle, güvenilir, şeffaf ve sonuç odaklı bir yaklaşımla müvekkillerine rehberlik etmektedir.
              </p>

              <div className="flex flex-wrap gap-4 pt-4">
                <Button asChild size="lg" className="h-14 px-8 text-base bg-primary-foreground text-primary hover:bg-white hover:text-primary transition-all duration-300 shadow-[0_0_20px_rgba(255,255,255,0.1)]">
                  <Link to="https://celikhukuk.net/iletisim/">
                    İletişime Geçin
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Link>
                </Button>
                
                <Button asChild variant="outline" size="lg" className="h-14 px-8 text-base border-primary/20 text-foreground hover:bg-primary/10 hover:text-primary-foreground transition-all duration-300">
                  <Link to="https://celikhukuk.net/calisma-alanlari/">
                    Çalışma Alanlarımız
                  </Link>
                </Button>
              </div>

              <div className="pt-8 flex items-center gap-8 text-sm text-white/60 font-mono">
                <div className="flex items-center gap-2">
                  <span className="text-white">01</span>
                  <span className="text-white">Güvenilirlik</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-white">02</span>
                  <span className="text-white">Şeffaflık</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-white">03</span>
                  <span className="text-white">Uzmanlık</span>
                </div>
              </div>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`w-full lg:w-[40%] h-[50vh] lg:h-full absolute lg:relative top-0 right-0 lg:block hidden transition-all duration-1000 delay-300 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <div className="relative h-full w-full overflow-hidden">
              {}
              <div className="absolute inset-0 bg-gradient-to-l from-transparent via-transparent to-background/90 z-10 lg:w-32" />
              <div className="absolute inset-0 bg-[#C5A059]/10 mix-blend-overlay z-10" />
              
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568729/img/modern_courthouse_architecture.png" alt="Modern adliye mimarisi ve hukuk bürosu temsili görseli" className="h-full w-full object-cover object-center grayscale-[20%] contrast-125" />
              
              {}
              <div className="absolute bottom-12 right-12 z-20 hidden lg:block">
                <div className="bg-background/90 backdrop-blur-md p-6 border border-white/10 shadow-2xl max-w-xs">
                  <p className="font-serif text-2xl text-muted-foreground mb-1">2017</p>
                  <p className="text-xs text-muted-foreground uppercase tracking-widest">Yılından Beri Hizmetinizde</p>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="w-full h-64 lg:hidden mt-8 relative rounded-lg overflow-hidden border border-white/10">
             <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568729/img/modern_courthouse_architecture.png" alt="Modern adliye mimarisi" className="h-full w-full object-cover object-center" />
              <div className="absolute inset-0 bg-[#C5A059]/10 mix-blend-overlay" />
          </div>

        </div>
      </div>
    </section>;
}